import Layout from "components/layout";
import Input from "components/form/input";
import Submit from "components/submit";

import * as contactApi from "api/legacy_contact";

import { useState } from "react";
import { useForm } from "react-hook-form";
import { useUser } from "hooks/user";
import { useNotifications } from "hooks/notifications";

export default function Contact() {
  const [loading, setLoading] = useState(false);

  const { register, handleSubmit, formState, reset } = useForm();
  const { user } = useUser();

  const { setNotification } = useNotifications();

  const inputOptions = {
    register,
    formState,
    options: { disabled: loading }
  };

  function onSubmit(attributes) {
    const identification = user ? { name: user.name, email: user?.email } : {};
    setLoading(true);
    contactApi.create({ ...attributes, ...identification }).then(() => {
      const email = user?.email || attributes.email;
      setNotification({
        title: "Mensagem enviada",
        text: `Obrigado pelo contato! Responderemos para o e-mail ${email}`,
        type: "success"
      });
      reset();
      setLoading(false);
    });
  }

  return (
    <Layout
      title="Contato"
      description="Tem alguma dúvida, crítica ou elogio? Manda uma mensagem pra gente, sua opinião é importante!"
      canonical="/contato"
    >
      <main>
        <div className="small-container">
          <header className="mb-6">
            <h1 className="mb-3">Entre em contato</h1>
            <p className="text-xl">Tem alguma dúvida ou sugestão?</p>
            <p className="text-emphasis-low">
              Você também pode usar esse formulário para solicitar a exclusão da
              sua conta e dados. O processo leva 20 dias úteis e nenhum dado que
              possa ser relacionado a você é mantido.
            </p>
          </header>

          <form onSubmit={handleSubmit(onSubmit)}>
            {!user && (
              <>
                <Input
                  name="name"
                  label="Nome completo"
                  validations={{ required: true }}
                  {...inputOptions}
                />
                <Input
                  name="email"
                  type="email"
                  label="E-mail"
                  validations={{ required: true }}
                  {...inputOptions}
                />
              </>
            )}

            <Input
              name="content"
              type="textarea"
              label="Mensagem"
              validations={{ required: true }}
              {...inputOptions}
            />

            <Submit loading={loading} className="btn btn-primary mt-2 w-full">
              Enviar
            </Submit>
          </form>
        </div>
      </main>
    </Layout>
  );
}
